<template>
    <div>
        <charts :chart_data="this.statistics" v-if="statistics_status === 'success'"></charts>
    </div>
</template>
<script>
    import charts from './charts'
    import { mapGetters } from "vuex";
    export default {
        name: "statistics",
        props: {
            call_starshop: {
                required: false,
                type: Boolean,
                default: false
            },  
        },
        components: {
            charts
        },
        computed: {
            ...mapGetters('transactionRouting', [
                'statistics', 'statistics_status'
            ])
        },
        mounted() {
            this.call_starshop ?
                this.$store.dispatch('transactionRouting/fetchStarshopStatistics') :
                this.$store.dispatch('transactionRouting/fetchCoreStatistics')
        }
}
</script>
<style scoped>
</style>